import _jsx from "@babel/runtime/helpers/jsx";
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import elementType from 'react-prop-types/lib/elementType';
import { prefix, splitBsProps, bsClass } from './utils/bootstrapUtils';
import PanelToggle from './PanelToggle';
import { PanelContext } from '../Panel/PanelContext';
class PanelTitle extends React.Component {
  render() {
    let {
      children
    } = this.props;
    const {
      className,
      toggle,
      componentClass: Component,
      ...props
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsProps(props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    if (toggle) {
      children = /*#__PURE__*/_jsx(PanelToggle, {}, void 0, children);
    }
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, elementProps, {
      className: cn(className, prefix(bsProps, 'title'))
    }), children);
  }
}
PanelTitle.defaultProps = {
  componentClass: 'div'
};
PanelTitle.contextType = PanelContext;
export default bsClass('panel', PanelTitle);